<div
  #sectionContent
  [attr.id]="sectionId"
  *ngIf="sectionItemsCount"
  class="kanban-section-container display-flex flex-column"
  [ngClass]="containerCss">
  <app-expandable-section
    [displayExpandIcon]="false"
    [isExpanded]="isExpandedEffective"
    (clickOverride)="toggleMenu()"
    (doubleClick)="toggleAllSections()">
    <div
      header
      class="display-flex align-items-center grid-gap-8"
      [matTooltip]="'Double click to ' + (isExpanded ? 'collapse' : 'expand') + ' all'">
      <div class="expanded-icon" [class.expanded]="isExpanded"></div>
      <span class="text-color gray17 label-caps">
        {{ kanbanListItem?.propertyName || '' }}
      </span>
      <span class="text-color gray17 label-caps">·</span>
      <span class="text-color gray17 label-caps">
        {{ sectionItemsCount + (sectionItemsCount > 1 ? ' turns' : ' turn') }}
      </span>
    </div>
    <ng-container [ngTemplateOutlet]="kanbanTableTemplate"></ng-container>
  </app-expandable-section>
</div>

<ng-template #kanbanTableTemplate>
  <div
    #sectionContainer
    class="preview-container position-relative"
    [ngClass]="[stepsBeforeTask ? 'active display-flex' : '']">
    <div class="preview-content display-flex grid-gap-20" [ngStyle]="previewContentCss">
      <ng-container
        *ngFor="let item of stepsBeforeTask?.stepBefore; let last = last; let index = index"
        appLastElement
        [isLastElement]="{ value: last, itemsCount: stepsBeforeTask.stepBefore?.length }"
        (lastElementLoaded)="animatePreview()">
        <div
          class="preview-card display-flex flex-column grid-gap-4 w-100 h-100"
          [ngClass]="[previewCss, index === 4 ? 'mr-4' : '', item.fakeHiddenStep ? 'hidden-step' : '']"
          [class.joined]="isJoined">
          <div class="pre-title unit-section text-color gray17">
            <div class="unit-section-title">
              <div class="unit-section-row">
                <span>
                  <mat-icon [inline]="true" [svgIcon]="'unit'"></mat-icon>
                  {{ stepsBeforeTask.unitName || '_' | truncateText: ['unit', '#'] }}
                </span>
              </div>
            </div>
          </div>
          <ng-container [ngSwitch]="turnoversFilters?.auditMode">
            <ng-container
              *ngSwitchCase="TurnoverAuditMode.ELAPSED_DAYS"
              [ngTemplateOutlet]="elapsedDayTemplate"
              [ngTemplateOutletContext]="{
                item: item,
                timeInStep: item?.workflowStepEnumType | dayInStep: stepsBeforeTask?.timerInstance,
                dateStarted:
                  item?.workflowStepEnumType === WorkflowStepEnumType.MoveOut
                    ? stepsBeforeTask.dateMoveOut
                    : item?.dateStarted,
                dateCompleted: item?.dateCompleted,
                step: item.workflowStepEnumType
              }"></ng-container>
            <ng-container
              *ngSwitchCase="TurnoverAuditMode.LOST_REVENUE"
              [ngTemplateOutlet]="lostRevenueDayTemplate"
              [ngTemplateOutletContext]="{
                item: item,
                timeInStep: item?.workflowStepEnumType | dayInStep: stepsBeforeTask?.timerInstance,
                unitRent: stepsBeforeTask?.unitRent,
                step: item.workflowStepEnumType
              }"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="labels-section"></div>
  </div>
  <div class="kanban-section-table-container display-flex w-100 grid-gap-12">
    <ng-container [ngTemplateOutlet]="isLoading ? spinnerTemplate : tableContainerTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #tableContainerTemplate>
  <ng-container [ngTemplateOutlet]="tableContentTemplate"></ng-container>
</ng-template>

<ng-template #tableContentTemplate>
  <div
    class="display-flex grid-gap-4 phase not-ready"
    [style.--kanban-section-ready-size]="kanbanReadySize"
    [style.--kanban-section-not-ready-size]="kanbanNotReadySize">
    <div class="display-flex flex-column grid-gap-8 column">
      <ng-container
        [ngTemplateOutlet]="section"
        [ngTemplateOutletContext]="{ section: evictionSection }"></ng-container>
    </div>
    <div
      *ngIf="!hiddenNotReadyColumns.has(WorkflowStepEnumType.Notice)"
      class="display-flex flex-column grid-gap-8 column">
      <ng-container [ngTemplateOutlet]="section" [ngTemplateOutletContext]="{ section: noticeSection }"></ng-container>
    </div>
    <div
      *ngIf="!hiddenNotReadyColumns.has(WorkflowStepEnumType.MoveOut)"
      class="display-flex flex-column grid-gap-8 column">
      <ng-container [ngTemplateOutlet]="section" [ngTemplateOutletContext]="{ section: moveOutSection }"></ng-container>
    </div>
    <div
      *ngIf="!hiddenNotReadyColumns.has(WorkflowStepEnumType.MakeReady)"
      class="display-flex flex-column grid-gap-8 column"
      [ngClass]="{ 'column-extended': extendMakeReadyColumn }">
      <ng-container
        [ngTemplateOutlet]="extendMakeReadyColumn ? sectionMakeReadyExt : section"
        [ngTemplateOutletContext]="{ section: makeReadySection }"></ng-container>
    </div>
    <div
      *ngIf="!hiddenNotReadyColumns.has(WorkflowStepEnumType.Reno)"
      class="display-flex flex-column grid-gap-8 column">
      <ng-container [ngTemplateOutlet]="section" [ngTemplateOutletContext]="{ section: renoSection }"></ng-container>
    </div>
    <div
      *ngIf="!hiddenNotReadyColumns.has(WorkflowStepEnumType.Punch)"
      class="display-flex flex-column grid-gap-8 column">
      <ng-container [ngTemplateOutlet]="section" [ngTemplateOutletContext]="{ section: punchSection }"></ng-container>
    </div>
    <div
      *ngIf="!hiddenNotReadyColumns.has(WorkflowStepEnumType.Approval)"
      class="display-flex flex-column grid-gap-8 column">
      <ng-container
        [ngTemplateOutlet]="section"
        [ngTemplateOutletContext]="{ section: approvalSection }"></ng-container>
    </div>
  </div>
  <div
    class="display-flex grid-gap-4 phase ready"
    [style.--kanban-section-ready-size]="kanbanReadySize"
    [style.--kanban-section-not-ready-size]="kanbanNotReadySize"
    [ngClass]="{ 'ready-size-1': kanbanReadySize === 1, 'ready-size-2': kanbanReadySize === 2 }">
    <div
      *ngIf="!hiddenReadyColumns.has(WorkflowStepEnumType.LeaseUp)"
      class="display-flex flex-column grid-gap-8 column">
      <ng-container [ngTemplateOutlet]="section" [ngTemplateOutletContext]="{ section: leaseUpSection }"></ng-container>
    </div>
    <div
      *ngIf="!hiddenReadyColumns.has(WorkflowStepEnumType.MoveIn)"
      class="display-flex flex-column grid-gap-8 column">
      <ng-container [ngTemplateOutlet]="section" [ngTemplateOutletContext]="{ section: moveInSection }"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #spinnerTemplate>
  <div class="display-flex justify-content-center align-items-center w-100">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template
  #elapsedDayTemplate
  let-item="item"
  let-dateStarted="dateStarted"
  let-dateCompleted="dateCompleted"
  let-timeInStep="timeInStep">
  <ng-container [ngSwitch]="timeInStep?.days || timeInStep?.hours">
    <ng-container
      [ngTemplateOutlet]="skippedStepTemplate"
      *ngSwitchCase="false"
      [ngTemplateOutletContext]="{ item: item }"></ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="item?.responsiblePartyId">
        <app-avatar
          *ngIf="{
            assignee: item?.responsiblePartyId | findById: allUsers
          } as data"
          [userInfo]="data.assignee"
          [containerCss]="'s-24'"
          [matTooltip]="'Assignee:'"
          [matTooltipPosition]="'above'"></app-avatar>
      </ng-container>
      <div
        [ngClass]="item.priority | thresholdPriorityCss"
        class="display-flex flex-column grid-gap-4 w-100 h-100 align-items-start py-6 border-box">
        <div class="audit-content display-flex align-items-end justify-content-center fade-truncate">
          <div class="nowrap">
            <span class="audit-label large">
              {{ timeInStep?.days }}
              <span class="audit-label small">d</span>
            </span>
            <span class="audit-label small">{{ timeInStep?.hours }}h</span>
          </div>
        </div>
        <div class="body-small text-color display-flex w-100 flex-auto align-items-end justify-content-center">
          <span>{{ dateStarted | date: 'MM/dd' }} - {{ dateCompleted | date: 'MM/dd' }}</span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #lostRevenueDayTemplate let-item="item" let-timeInStep="timeInStep" let-unitRent="unitRent">
  <ng-container [ngSwitch]="timeInStep | lostRevenue: unitRent">
    <ng-container
      [ngTemplateOutlet]="skippedStepTemplate"
      *ngSwitchCase="0"
      [ngTemplateOutletContext]="{ item: item }"></ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="item?.responsiblePartyId">
        <app-avatar
          *ngIf="{
            assignee: item?.responsiblePartyId | findById: allUsers
          } as data"
          [userInfo]="data.assignee"
          [containerCss]="'s-24'"
          [matTooltip]="'Assignee:'"
          [matTooltipPosition]="'above'"></app-avatar>
      </ng-container>
      <div class="audit-content audit-content-lost justify-content-center display-flex nowrap fade-truncate">
        <div [ngClass]="item.priority | thresholdPriorityCss">
          <span class="audit-label small">{{ (timeInStep | lostRevenue: unitRent) ? NoValue : '' }}$</span>
          <span class="audit-label large">{{ timeInStep | lostRevenue: unitRent }}</span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #skippedStepTemplate let-item="item">
  <div class="flex-auto display-flex justify-content-center dash-wrapper">
    <div class="dash-container">
      <div class="dash"></div>
    </div>
  </div>
</ng-template>

<ng-template #section let-section="section">
  <ng-container *ngFor="let item of section; trackBy: trackByFn">
    <div [hidden]="!item.visible">
      <app-kanban-card
        class="w-100"
        [item]="item.item"
        (selectCardEvent)="openTurnover(item.item)"
        (inspectionModeToggleEvent)="previewInspectedItem($event)"
        [isJoined]="isJoined"></app-kanban-card>
    </div>
  </ng-container>
</ng-template>

<ng-template #sectionMakeReadyExt let-section="section">
  <app-kanban-section-make-ready-extended
    [section]="section"
    (selectCardEvent)="openTurnover($event)"
    (inspectionModeToggleEvent)="previewInspectedItem($event)"
    [isJoined]="isJoined"></app-kanban-section-make-ready-extended>
</ng-template>
